(function () {
    'use strict';
    angular.module('AngularAdmin')
        .factory('MaterialSvc', ['$http', function ($http) {
            let COLORS = [
                //"#2090A7","#94211A","#6D5BD7","#CD8927","#7820A7","#65CD73","#198679","#864918","#B6934C","#5360AC","#23719F","#866819","#9F4CB6","#AC4309","#867A3C","#866974","#A6B65B","#AC2909","#523002","#0A3852","#523002","#9F6A23"
                //  , "#1DAC94", "#1FA6B6"
                "#23719F", "#34A7EB", "#5B90AF", "#7AC2EB", "#184D6C", "#53C593", "#AC373A", "#F84F54", "#BA7375", "#F89A9D", "#EBE828", "#6B6A12", "#B8B61F", "#392E6E", "#7C64ED", "#973CBA", "#816F87", "#BA923C", "#F0DFA1", "#3A2E13"
            ];
            return {
                list: function (plant_id) {
                    let url = `/plant/${plant_id}/materials/`;

                    return $http.get(url, {});
                },
                listToIdMap: function (list) {
                    let map = {};
                    for (var i = list.length - 1; i >= 0; i--) {
                        map[list[i].id] = list[i];
                    }
                    return map;
                },
                create: function (material, plant_id) {
                    let url = String.format('/plant/{0}/material/new/', plant_id, material.id);
                    return $http({
                        method: 'POST',
                        url: url,
                        data: material
                    });
                },
                update: function (material, plant_id) {
                    let url = String.format('/plant/{0}/material/{1}/', plant_id, material.id);
                    return $http({
                        method: 'PUT',
                        url: url,
                        data: material
                    });
                },
                get: function (material_id, plant_id) {
                    let url = String.format('/plant/{0}/material/{1}/', plant_id, material_id);
                    return $http.get(url, {});
                },
                getMaterialColor: function (material_id, plant_id) {
                    let index = (parseInt(material_id) + parseInt(plant_id)) % COLORS.length;
                    return COLORS[index];
                },
                can_delete: function (material_id, plant_id) {
                    let url = String.format('/plant/{0}/material/{1}/is_deletable/', plant_id, material_id);
                    return $http.get(url, {});
                },
                delete: function (material_id, plant_id) {
                    let url = String.format('/plant/{0}/material/{1}/delete/', plant_id, material_id);
                    return $http({
                        method: 'DELETE',
                        url: url
                    });
                }
            };
        }]);

})();
